import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    title: 'Bot is not available',
    description: "Remove other bots' names from your Telegram name, otherwise the ban will be permanent.",
  },
  ru: {
    title: 'Бот тебе не доступен',
    description: 'Убери имена других ботов из своего имени в Telegram, иначе бан будет навсегда.',
  },
  uz: {
    title: 'Bot siz uchun mavjud emas',
    description: 'Telegram ismingizdan boshqa botlarning nomlarini olib tashlang, aks holda ban abadiy boʻladi.',
  },
  fa: {
    title: 'ربات در دسترس نیست',
    description: 'نام ربات‌های دیگر را از نام تلگرامت پاک کن، وگرنه مسدودی دائمی می‌شود.',
  },
  pt: {
    title: 'O bot não está disponível para você',
    description: 'Tire os nomes de outros bots do seu nome no Telegram, senão o banimento vai ser permanente.',
  },
  tr: {
    title: 'Bot senin için kullanılamıyor',
    description: 'Telegram adından diğer botların adlarını kaldır, yoksa yasak kalıcı olur.',
  },
});
